export const URI_BOOKINGS = 'bookings';
export const URI_BOOKING_CALENDAR = 'calendar';
export const URI_BOOKING_STAFF = 'staff';
export const URI_BOOKING_CATEGORIES = 'categories';
export const URI_BOOKING_TEMPLATES = 'templates';
export const URI_BOOKING_SETTINGS = 'settings';
